import React, { useEffect }  from 'react';

import {
    Link,
    withRouter,
    useHistory
} from "react-router-dom";

import {makeStyles, withStyles} from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import Grid from '@material-ui/core/Grid'
import Container from '@material-ui/core/Container'
import IconButton from '@material-ui/core/IconButton'
import AddCircleIcon from '@material-ui/icons/AddCircle'
import Breadcrumbs from '@material-ui/core/Breadcrumbs'
import Home from '@material-ui/icons/Home'
import Typography from '@material-ui/core/Typography'
import MaterialTable from 'material-table';

import Autocomplete from "@material-ui/lab/Autocomplete";
import Chip from "@material-ui/core/Chip";
import TextField from "@material-ui/core/TextField";

import Select from '@material-ui/core/Select'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import TextareaAutosize from '@material-ui/core/TextareaAutosize'
import Button from '@material-ui/core/Button'

import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from '@material-ui/core/FormControl';
import Switch from "@material-ui/core/Switch";
import FormGroup from '@material-ui/core/FormGroup'
import Checkbox from '@material-ui/core/Checkbox'
import ListDashboardOrdered from "../../component/DragAndDrop/ListDashboardOrdered";


//Services
import UserService from "../../services/UserService";
import CompanyService from "../../services/CompanyService";
import DatasetDynamicService from "../../services/DatasetDynamicService";
import DashboardService from "../../services/DashboardService";
import AutocompleteCompany from "../../component/Autocomplete/AutocompleteCompany";
import AutocompleteUser from  '../../component/Autocomplete/AutocompleteUser';
import AlertGeneral from "../../component/AlertGeneral/AlertGeneral";

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        marginTop: 20,
        marginBottom: 400,
    },
    paper: {
        // padding: theme.spacing(5),
        // color: theme.palette.text.secondary,
    },
    formControl: {
        margin: theme.spacing(2),
    },
    button: {
        margin: theme.spacing(1),
    },
    textArea: {
        width: '100%',
    },
    formHead: {
        backgroundColor:'#ffffff',
        marginTop: 50,
    }
}));

class DashboarAdd extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            id: this.props.match.params.id,
            company: {"id":"","label":"","socialName":"","identifier":""},
            companies:[],
            companiesSelected: [],
            user: {"id": "", "label": "", "companyName": "", "company": ""} ,
            users:[],
            userSelected: [],
            description: "",
            enable: true,
            dataset:{ "id":"", "description":"", "companies":[], "users":[]},
            datasetStatusDisable: true,
            datasets:[],
            listDatasetDb:[],
            order: 0,
            alerts: {
                open: false,
                severity: "success",
                msg: 'Dashboard salvo com sucesso!'
            },
        }
    }

    componentDidMount(prevProps) {
        this.loadingAll();
        // const close = document.getElementsByClassName(
        //     "MuiAutocomplete-clearIndicator"
        // )[0];
        //
        // // Add a Click Event Listener to the button
        // close.addEventListener("click", () => {
        //     alert("Add your Own Functionality Here...");
        // });
    }

    componentDidUpdate(prevProps) {

        if(this.props.match.params.id !== prevProps.match.params.id) {
            this.loadingAll();
        }

    }

    loadingAll = () => {

        if(this.state.id) {
            const response = DashboardService.searchAllDataById(this.state.id);
            response.then(resp => {
                this.applyDatasInComponentFromBack(resp);

            }).catch(error => console.error(error))
        }
    }

    applyDatasInComponentFromBack = (resp) => {

        const dashboard = resp.data.dashboard;
        const companiesFromBack = resp.data.companies;
        const usersFromBack = resp.data.users;

        //cria o objeto de empresa
        const companiesDidMount = [];
        companiesFromBack.map((item, index )=> {
            companiesDidMount.push({id: item.empTid, identifier: item.empCnpjcpf, label: item.empNome, socialName: item.empRazaoSocial});
        })

        //Cria o objeto de usuáiro
        const userDidMount = [];
        usersFromBack.map((item, index) => {
            userDidMount.push({"id": item.id, "label": item.email, "company": item.companyId})
        })

        this.setState({
            description: dashboard.name,
            enable: dashboard.enable,
            order: dashboard.order,
            companiesSelected: companiesDidMount,
            userSelected: userDidMount,
            listDatasetDb: resp.data.datasetDynamics,
            datasetStatusDisable: !companiesDidMount.length > 0
        });

        //Carrega os usuários nas lista
        this.searchUsersByCompany(companiesDidMount);
    }

    handlerUserslectItem  = (option, param) => {
        this.setState({userSelected: param})
    }

    handleCompanySelectItem = (option, param) => {

        let isRemoveUserFromList = false;

        if((!param || param.length < 1) && this.state.listDatasetDb.length > 0){
            if(window.confirm("Será removido a lista de dataset")) {

                this.setState({listDatasetDb: []});

            } else{
                return;
            }
        }

        if(this.state.userSelected.length > 0){
            if(window.confirm("Serão removidos os usuários pertinentes as empresas alteradas. Continuar?")) {

                isRemoveUserFromList = true;

            } else {
                return;
            }
        }

        this.setState({companiesSelected: param});

        this.searchUsersByCompany(param);

        if(param && param.length > 0){
            this.setState({datasetStatusDisable: false});
        } else {
            this.setState({datasetStatusDisable: true});
        }

        //Remover os usuários que não pertence a lista de param
        if(isRemoveUserFromList){

            let newUserLIst = [];
            param.forEach((company) => {
                this.state.userSelected.forEach((user) => {
                    if(user.company === company.id){
                        newUserLIst.push(user);
                    }
                } )
            });
            this.setState({userSelected: newUserLIst});

        }

    }

    handleCompany = (event) => {
        this.searchCompanyByTerm(event.target.value.trim())
    }

    handleSearchCompanyDefault = () => {
        this.searchCompanyByTerm('ads')
    }


    searchCompanyByTerm = (term) => {

        if(!term || term.length < 2) return

        const companiesResponse = CompanyService.companies(term)
        companiesResponse
            .then(resp => {
                this.setState({companies: resp.data});
            })
            .catch(err => {
                console.error(err)
            })
    }

    handlerDataset = (event) => {
        let term = event.target.value;
        this.setState({dataset: { "id":"", "description":term, "companies":[], "users":[]}});
        this.searchDatasetByTerm(term);
    }

    handleDataserSelectItem = (option, param) => {
        this.setState({dataset:param});
        this.addlistDatasetDb(param);
    }

    addlistDatasetDb = (param) => {
        if(!param) return;

        let item = this.state.listDatasetDb.find((currentValue, index, arr) => currentValue.id === param.id);
        if(item){
            alert("Este dataset já existe: " + param.id);
            return;
        }
        let list = this.state.listDatasetDb;
        list.push(param)
        this.setState({listDatasetDb: list})
    }

    searchDatasetByTerm = (term) => {

        if(!term || term.length < 3) return

        if(this.state.companiesSelected && this.state.companiesSelected.length < 1) return;

        const ids = this.state.companiesSelected.map((item) => item.id + "");

        const searchFilter = {
            term: term,
            companies: ids
        }

        const response = DatasetDynamicService.searchByTerm(searchFilter);
        response
            .then(resp => {
                this.setState({datasets: resp.data});
            })
            .catch(err => {
                console.error(err)
            })
    }

    searchUsersByCompany = (param) => {

        if(!param || param.length < 1) return

        const ids = [];
        param.map((item, index)=> ids.push(item.id));

        const userResponse = UserService.user(ids)
        userResponse
            .then( resp => {
                this.setState({users: resp.data});
            })
            .catch(err => {
                console.error(err)
            })
    }

    handlerDescription = (event) => {
        this.setState({description: event.target.value})
    }

    handlerOrder = (event) => {
        this.setState({order: event.target.value})
    }



    handleEnable = (event) => {
        this.setState({enable: event.target.checked})
    }

    handleOrder = (newOrder) => {
        this.setState({listDatasetDb: newOrder});
    }

    handleListSimpleRemove = (id) => {
        if(!id) return;
        // let item = this.state.listDatasetDb.find((currentValue, index, arr) => currentValue.id === id);
        // let index = this.state.listDatasetDb.indexOf(item);
        let newlistDatasetDb = [];
        for(var i = 0; i<this.state.listDatasetDb.length; i++){
            if(this.state.listDatasetDb[i].id !== id) {
                newlistDatasetDb.push(this.state.listDatasetDb[i]);
            }
        }
        this.setState({listDatasetDb: newlistDatasetDb})
    }

    handleSave = () => {

        const {history} = this.props

        const companies = this.state.companiesSelected.map((item, index) =>  item.id);
        const users = this.state.userSelected.map((item, index) =>  item.id);
        const listDatase = this.state.listDatasetDb.map((item, indes) => item.id);

        let itemToSave = {
            id: this.state.id,
            name: this.state.description,
            datasetDynamicId: listDatase,
            order: this.state.order,
            companies: companies,
            users: users,
            enable: this.state.enable
        }

        const response = DashboardService.save(itemToSave);
        response
            .then( resp => {

                this.setState({
                    alerts: {
                        open: true,
                        severity: "success",
                        msg: 'Dashboard foi salvo com sucesso!'
                    }
                })

                if(!this.state.id){
                    const url = `/dashboard/add/${resp.data.id}`;
                    try{
                        history.push(url);
                    }catch (error){
                        window.location.reload(false);
                    }
                }

            })
            .catch(err => {
                console.error(err)
            })
    }

    handleCloseAlert = () => {
        this.setState({
            alerts: {
                open: false
            }
        })
    }

    render(){

        const { classes } = this.props;

        return (
            <Container className={classes.root} >

                <Grid >

                <AlertGeneral status={this.state.alerts} onEventClose={this.handleCloseAlert} />

                <Grid item xs={12} container justify="flex-end" >

                    <Grid item xs={6}   spacing={3} >
                        <Breadcrumbs aria-label="breadcrumb">
                            <Link color="inherit" to="/"  >
                                <Home/>
                            </Link>
                            <Link to="/dashboad/list"  >
                                Dashboards
                            </Link>

                            <Typography color="textPrimary">
                                Dashboard: {this.state.description}
                            </Typography>
                        </Breadcrumbs>
                    </Grid>

                    <Grid xs={6} container justify="flex-end" onClick={this.handleSave} >
                        <Button variant="contained" color="primary" >Salvar</Button>
                    </Grid>

                </Grid>

                <hr/>

                <Grid  style={{ backgroundColor:"white", padding: '20px 10px' }} >

                    <Grid item xs={12} container justify="flex-end" >

                        <Grid xs={8}  >

                            <TextField
                                label="Descrição"
                                fullWidth
                                value={this.state.description}
                                onChange={this.handlerDescription}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />

                        </Grid>

                        <Grid xs={2}  >

                            <TextField
                                label="Ordem"
                                fullWidth
                                value={this.state.order}
                                onChange={this.handlerOrder}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />

                        </Grid>


                        <Grid xs={2}   justify="flex-end" >
                            <FormGroup row>
                                <FormControlLabel
                                    control={<Switch checked={this.state.enable} onChange={this.handleEnable} />}
                                    label="Ativo"
                                />
                            </FormGroup>
                        </Grid>
                    </Grid>


                    <Grid item xs={12}  >
                        <Autocomplete
                            value={this.state.companiesSelected}
                            onChange={this.handleCompanySelectItem}
                            onKeyUp={this.handleCompany}
                            multiple
                            filterSelectedOptions
                            options={this.state.companies}
                            getOptionLabel={(option) => {
                                return option.id +" - " + option.label;
                            }}
                            getOptionSelected={(option, value) => option.label === value.label}
                            renderOption={(option) => {
                                return `${option.id} | ${option.label} | ${option.identifier ? `cnpj ${option.identifier}`:''}`
                            }}
                            renderTags={(value, getTagProps) =>
                                value.map((option, index) => (
                                    <Chip
                                        color="primary"
                                        label={option.id + ' ' + option.label}
                                        {...getTagProps({ index })}
                                    />
                                ))
                            }
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    onClick={this.handleSearchCompanyDefault}
                                    variant="standard"
                                    label="Empresas"
                                    placeholder="Selecione"
                                />
                            )}
                        />
                    </Grid>

                    <Grid item xs={12} >

                            <Autocomplete
                                value={this.state.userSelected}
                                onChange={this.handlerUserslectItem}
                                multiple
                                filterSelectedOptions
                                options={this.state.users}
                                getOptionLabel={(option) => option.username}
                                getOptionSelected={(option, value) => option.id === value.id}

                                renderOption={(option) => {
                                    return `${option.id} | ${option.label} | ${option.username} | ${option.company}`
                                }}
                                renderTags={(value, getTagProps) =>
                                    value.map((option, index) => (
                                        <Chip color="primary" label={option.label} {...getTagProps({ index })} />
                                    ))
                                }
                                renderInput={(params) => (
                                    <TextField
                                        label="Usuários"
                                        {...params}
                                        variant="standard"
                                    />
                                )}
                            />

                    </Grid>

                    <Grid item xs={12}  >

                        <Autocomplete
                            disabled={this.state.datasetStatusDisable}
                            value={this.state.dataset}
                            options={this.state.datasets}
                            filterSelectedOptions
                            getOptionLabel={(row) => row.description}
                            getOptionSelected={(option, value) => option.id === value.id}
                            onChange={this.handleDataserSelectItem}
                            onKeyUp={this.handlerDataset}
                            renderOption={(option) => {
                                return `${option.description}`
                            }}
                            renderTags={(value, getTagProps) =>
                                value.map((option, index) => (
                                    <Chip color="primary" label={option.label} {...getTagProps({ index })} />
                                ))
                            }
                            renderInput={(params) => (
                                <TextField
                                    label="Seleção de dataset"
                                    {...params}
                                    variant="standard"
                                />
                            )}
                        />

                    </Grid>



                </Grid>

                {this.state.listDatasetDb.length > 0 ? <h1>Datasets ordem</h1> : ''}

                <Grid xs={12} className={classes.formControl} >
                    <ListDashboardOrdered datasets={this.state.listDatasetDb} onEventChange={this.handleOrder} eventRemove={this.handleListSimpleRemove} />
                </Grid>

            </Grid>

            {this.state.listDatasetDb.length > 0 ? <h1>Pré visualização</h1> : ''}

            <Grid xs={12} >
                {this.state.listDatasetDb.map((item) => <Grid xs={item.spaceWidth}
                                                              container
                                                              justifyContent="center"
                                                              alignItems="center"
                                                              style={{ backgroundColor:"#FFF",
                                                                  justifyContent: "center",
                                                                  height: item.spaceHeight,
                                                                  margin: 10, padding: 20,
                                                                  border: '2px dashed #ccc'}} >
                                                                    <di>
                                                                        <h3>{item.description}</h3>
                                                                        <h5>Saída: {item.out}</h5>
                                                                        <h6>Ocupa: {item.spaceWidth} colunas</h6>
                                                                        <h6>Altura: {item.spaceHeight}px</h6>
                                                                    </di>
                                                            </Grid>)}
            </Grid>

            </Container>
        );
    }

}

export default withStyles(useStyles)(withRouter(DashboarAdd))